import React from 'react';
import {
  Modal,
  Paper,
  Typography,
  TextField,
  Box,
  Button,
  CircularProgress,
} from '@material-ui/core';
import { format } from 'date-fns';

import {
  DonationDisbursementCorporateGivingType,
  DonationDisbursementType,
} from 'generated/graphql';

type InvoiceCreationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  poNumber: string;
  onPoNumberChange: (value: string) => void;
  paymentDueDate: string;
  onPaymentDueDateChange: (value: string) => void;
  isLoading: boolean;
} & (
  | {
      donationDisbursementType: DonationDisbursementType.PayrollDonation;
      selectedCount: number;
    }
  | {
      donationDisbursementType: DonationDisbursementCorporateGivingType;
      givingAccountName: string;
      dateTo: Date;
    }
);

export const InvoiceCreationModal = (props: InvoiceCreationModalProps) => {
  const {
    open,
    onClose,
    onConfirm,
    poNumber,
    onPoNumberChange,
    paymentDueDate,
    onPaymentDueDateChange,
    isLoading,
    donationDisbursementType,
  } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        style={{
          padding: 32,
          width: 600,
          outline: 'none',
          borderRadius: 8,
        }}
      >
        <Typography variant="h5" component="h2" style={{ marginBottom: 16, fontWeight: 500 }}>
          Confirm {donationDisbursementType} Invoice Creation
        </Typography>
        <Typography variant="body1" style={{ marginBottom: 24, color: '#666' }}>
          {donationDisbursementType === DonationDisbursementType.PayrollDonation
            ? `Are you sure you want to create an invoice for ${
                props.selectedCount
              } selected pay cycle${props.selectedCount && props.selectedCount > 1 ? 's' : ''}?`
            : `Are you sure you want to create a ${donationDisbursementType} invoice for "${
                props.givingAccountName
              }" giving account for disbursements until ${format(props.dateTo, 'MM/dd/yyyy')}?`}
        </Typography>

        <TextField
          fullWidth
          label="Payment Due Date"
          type="date"
          variant="outlined"
          value={paymentDueDate}
          onChange={(e) => onPaymentDueDateChange(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            min: format(new Date(), 'yyyy-MM-dd'),
          }}
          style={{ marginBottom: 24 }}
        />

        <TextField
          fullWidth
          label="PO Number"
          variant="outlined"
          multiline
          value={poNumber}
          onChange={(e) => onPoNumberChange(e.target.value)}
          style={{ marginBottom: 24 }}
        />

        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isLoading}
            style={{ marginRight: 16 }}
          >
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? <CircularProgress size={24} /> : 'Create Invoice'}
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};
